var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"id":"container","trigger":"click","height":"520px"}},_vm._l((_vm.images),function(image){return _c('el-carousel-item',{key:image.id},[_c('div',{staticClass:"image",style:({
        background: 'url(' + image.path + ') no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'})})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }